// Yalnızca ön yüz doğrulaması; backend (ASP.NET Identity) kendi
// politikasını ayrıca uygular.

export const PASSWORD_MIN_LENGTH = 8;

const RULES = [
  {
    key: 'minLength',
    label: `At least ${PASSWORD_MIN_LENGTH} characters`,
    test: pw => pw.length >= PASSWORD_MIN_LENGTH,
  },
  {
    key: 'digit',
    label: 'At least 1 number (0-9)',
    test: pw => /[0-9]/.test(pw),
  },
  {
    key: 'lowercase',
    label: 'At least 1 lowercase letter (a-z)',
    test: pw => /[a-z]/.test(pw),
  },
  {
    key: 'uppercase',
    label: 'At least 1 uppercase letter (A-Z)',
    test: pw => /[A-Z]/.test(pw),
  },
  {
    key: 'special',
    label: 'At least 1 special character',
    test: pw => /[^A-Za-z0-9]/.test(pw),
  },
];

export const PASSWORD_RULE_TEXT =
  'Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.';

/**
 * @param {string} password
 * @returns {{ isValid: boolean, rules: Array<{key: string, label: string, passed: boolean}> }}
 */
export const validatePassword = password => {
  // null/undefined/sayı vb. gelirse güvenli davran
  const pw = typeof password === 'string' ? password : '';

  const rules = RULES.map(rule => ({
    key: rule.key,
    label: rule.label,
    passed: rule.test(pw),
  }));

  return {
    isValid: rules.every(rule => rule.passed),
    rules,
  };
};

export const isValidPassword = password => validatePassword(password).isValid;

export default validatePassword;
